/* global google */

export function initMap()
{
	const map = new google.maps.Map(document.getElementById("map"), {
		center: {lat: 50.451363, lng: 13.399767},
		zoom: 14,
		disableDefaultUI: true,
		styles: [
			{
				"elementType": "labels",
				"stylers": [
					{
						"visibility": "off"
					}
				]
			}
		]
	});

	const marker = new google.maps.Marker({
		position: {lat: 50.451363, lng: 13.399767},
		map: map,
		title: "CNC Chomutov s.r.o.",
		url: "https://maps.app.goo.gl/pmThKoyA9Vt7Y9PN6",
		icon: {
			url: "/dist/img/map_marker.svg",
			size: new google.maps.Size(50, 50),
			origin: new google.maps.Point(0, 0),
			anchor: new google.maps.Point(25, 50),
			scaledSize: new google.maps.Size(50, 50)
		}
	});

	google.maps.event.addListener(marker, "click", function() {
		window.open(marker.url);
	});
}
